module.exports = "https://static.im-cdn.com/mjc/storefront/Florencia/static/media/LChevron1.e3a1dc22.svg";